import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useNotification } from "../../../../hooks/notifications/useNotification";
import { parseGdbSchema, parseKmlSchema, parseSchema } from "../../../../evergis/core/import/parseSchema";
import { importFile } from "../../../../resources/import";

import { FileData } from "./useFileLoader";
import { DataSchema } from "../types";

type UseDataSchemaResult = {
  dataSchema: DataSchema;
  loadingSchema: boolean;
  fileUploaded: boolean;
  isTableSchema: boolean;
};

export const useDataSchema = (file: FileData): UseDataSchemaResult => {
  const { t } = useTranslation("dialogs");

  const [importFetch, { data, loading: loadingSchema, error }] = importFile.use();

  const isTableSchema = ["xls", "xlsx", "csv"].includes(data?.type);
  const isKml = ["kml", "kmz"].includes(data?.type);
  const isGdb = data?.type === "gdb";

  useNotification(file.id && error, {
    error: true,
    title: t("import.fileUploadError"),
    description: `${file.name}. ${t("import.tryAgain")}`,
  });

  const dataSchema = data && file.id ? data : undefined;
  const fileUploaded = dataSchema !== undefined;
  const schemaParsed = isKml
    ? parseKmlSchema(dataSchema)
    : isGdb
    ? parseGdbSchema(dataSchema)
    : parseSchema(dataSchema);

  useEffect(() => {
    if (file.id) {
      importFetch({
        input: {
          fileId: file.id,
        },
      });
    }
  }, [file.id]);

  return {
    dataSchema: schemaParsed,
    loadingSchema,
    fileUploaded,
    isTableSchema,
  };
};
